/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Cookie_SettingsInputs */

const en_footer_cookie_settings = /** @type {(inputs: Footer_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie settings`)
};

/**
* | output |
* | --- |
* | "Cookie settings" |
*
* @param {Footer_Cookie_SettingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_cookie_settings = /** @type {((inputs?: Footer_Cookie_SettingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Cookie_SettingsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_cookie_settings(inputs)
});